// Dubai - AC water leaking (problem page).
const content = {
    slug: 'ac-water-leaking',
    title: 'AC Water Leaking in Dubai? Causes and Fixes | StringsSG',
    description: (c) =>
        `Water dripping from your AC or ceiling grille in Dubai? Usually a blocked drain. Drain flush from ${c.money(c.tables.drainFlush[0].price)}, or cleaning from ${c.money(c.tables.general[0].wall)}.`,
    eyebrow: 'Dubai · AC water leaking',
    h1: 'AC Water Leaking in Dubai?',
    lead: 'A Dubai AC pulls litres of water out of the air every day. When that water cannot leave, it ends up on your floor, your sofa or your downstairs neighbour\'s ceiling. The fix is usually quick - here is what causes it.',
    image: 'blog/living/aircon-leaking-water.jpg',
    imageAlt: 'Water dripping from an indoor AC unit',
    facts: ['Usually a blocked drain', 'Fix the same day', 'Stop the damage early'],
    ctaLabel: 'Book a drain flush',
    priceTitle: 'Drain flush prices',
    priceIntro: 'Flushes the drain tray and condensate line to clear slime and dust. If the coil is also dirty, add a cleaning on the same visit - the technician will tell you.',
    panel: { type: 'drainFlush' },
    sections: [
        {
            title: 'Do this first',
            items: [
                'Switch the unit off at the controller so it stops producing water.',
                'Put a towel or bucket under the drip and move electronics away.',
                'If water is coming through a ceiling grille or a light fitting, switch off that circuit and call us - do not keep the unit running.',
                'Tell building management if water may reach the apartment below.',
            ],
        },
        {
            title: 'Why ACs leak in Dubai',
            tone: 'muted',
            cards: [
                { title: 'Blocked drain line', body: 'The usual cause. Dust from the coil mixes with condensate and grows into slime that plugs the line. Fixed with a flush.' },
                { title: 'Overflowing drain tray', body: 'In humid coastal months the tray fills faster than a part-blocked line can empty it. Same fix.' },
                { title: 'Frozen coil melting', body: 'A clogged filter or low gas freezes the coil; when it thaws, the tray overflows. Clean the filter; if it keeps freezing, check the gas.' },
                { title: 'Disconnected or sagging pipe', body: 'Above false ceilings, drain pipes can come loose or sag. The technician reseats and supports them.' },
            ],
        },
        {
            title: 'Ducted units leak where you cannot see',
            paragraphs: [
                'With a concealed ducted unit, the first sign is often a brown stain on the ceiling board or water dripping from a supply diffuser in a different room. By then the tray above the ceiling has been overflowing for a while. Mention any ceiling stains when you book - the technician checks the tray, the line and the insulation around the pipes.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Why is water dripping from my AC in Dubai?',
            answer: 'Almost always a blocked condensate drain or an overflowing drain tray. Less often, a frozen coil thawing, or a loose drain pipe above the ceiling.',
        },
        {
            question: 'Is a leaking AC dangerous?',
            answer: 'Water near electrics is. If water is coming through light fittings or near sockets, switch off that circuit and the AC, and get it checked.',
        },
        {
            question: 'How much does it cost to fix a leaking AC?',
            answer: (c) => `A drain flush costs ${c.money(c.tables.drainFlush[0].price)} for one unit. If the leak is caused by a dirty coil, a cleaning (${c.money(c.tables.general[0].wall)}) fixes both.`,
        },
    ],
    schema: {
        name: 'AC Water Leak Repair in Dubai',
        serviceType: 'Air conditioner drain cleaning',
        offers: (c) => [
            { name: 'Drain pipe flush, 1 unit', price: c.tables.drainFlush[0].price },
            { name: 'Drain pipe flush, 2 units', price: c.tables.drainFlush[1].price },
        ],
    },
}

export default content
